export default String.raw`
{% assign incSplit = include | Split:'|' -%}
{% assign daId = incSplit[0] | ToInt -%}
{% assign da = customer.DeliveryAddresses[daId] -%}

<div class="message-popup-background container-to-delete-js">
	<div class="change-data-container">
		<div class="data-form">
			<div class="data-form__header">
				{{ translations.DelivAddressEdition }}
				<button class="close-button replace-template-js close-js" data-container=".delivery-addresses-container-js" data-template="partials/customer-profile/customer-details/deliv-addresses.html" aria-label="{{ translations.Close }}">
					<svg aria-hidden="true" width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use></svg>
				</button>
			</div>
			<div class="form-js form-into-data-js">
				<input type="hidden" name="addressId" value="{{ da.Id }}" >
				{% if da.Default == false -%}
				<div class="toggle-button">
					<input id="cbx" type="checkbox" name="default">
					<label role="switch" tabindex="0" aria-checked="false" class="toggle" for="cbx"><span></span></label>
					<span class="text">{{ translations.SetAsDefault }}</span>
				</div>
				{% endif -%}
				<div class="da-js">
					{% include 'partials/common/address-form.html' with include -%}
				</div>
				<div class="required-fields"><span class='required'>*</span> {{ translations.RequiredFields }}</div>
				<input type="hidden" name="__action" value="Customer/DeliveryAddressUpdate" >
				<button class="primary-action-button post-js" data-container=".delivery-addresses-container-js" data-template="partials/customer-profile/customer-details/deliv-addresses.html">
					{{ translations.SaveChanges }}
				</button>
			</div>
		</div>
	</div>
</div>
`